"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { Spinner } from "@/components/ui/spinner";

interface LayoutWrapperProps {
  children: React.ReactNode;
}

export default function LayoutWrapper({ children }: LayoutWrapperProps) {
  const pathname = usePathname();
  const isStudio = useMemo(() => pathname?.startsWith("/studio") ?? false, [pathname]);

  if (isStudio) {
    return <>{children}</>;
  }

  return (
    <div className="relative isolate">
      <div
        className="initial-spinner-overlay fixed inset-0 z-[1000] flex items-center justify-center bg-bg transition-opacity duration-300"
      >
        <Spinner className="size-10 text-mocha" />
      </div>
      <div
        className="initial-aurora absolute inset-x-0 -top-40 h-[500px] -z-10 bg-gradient-aurora transition-opacity duration-700 ease-out"
      />
      <main
        id="main-content"
        className="initial-main-content transition-all duration-600 ease-out"
      >
        {children}
      </main>
    </div>
  );
}
